<template>
  
  <div>    
    <b-row>
      <b-col class="col-4">
        <b-form-group>
          <label for="agency">Search</label>  
          <b-input-group>
            <b-form-input v-model="filter" placeholder="Type to Search" />
            <b-input-group-append>
              <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col class="col-3">
        <b-form-group>
          <label for="agency">Field</label>  
          <b-input-group>            
            <b-form-select v-model="sortBy" :options="sortOptions">
              <option slot="first" :value="null">-- none --</option>
            </b-form-select>
            <b-form-select :disabled="!sortBy" v-model="sortDesc" slot="append">
              <option :value="false">Asc</option>
              <option :value="true">Desc</option>
            </b-form-select>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col class="col-4">
        <b-form-group>
          <label for="agency">Agency / Organization</label>  
          <b-form-select v-model="agencyId" ref="agencyId"
                       type="text" placeholder="Agency" 
                       text-field="name" 
                       value-field="id" 
                       :options="agencyList" @change="agencyChangeHandler"> 
          </b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>      
       <b-col sm="12">       
        <b-table hover="hover" small="small" striped="striped" bordered="bordered" responsive="sm" 
            ref="table"
            :items="myProvider" 
            :fields="fields" 
            :current-page="currentPage" 
            :per-page="perPage"
            @filtered="onFiltered" 
            :filter="filter"
            sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            :busy.sync="isBusy"
            :no-provider-paging="noProviderPaging"
            :no-provider-filtering="noProviderFiltering"
            :no-provider-sorting="noProviderSorting">

          <template slot="created_date" slot-scope="data">
            {{data.item.created_date | formatDate('DD/MM/YYYY HH:mm:ss')}} 
          </template>
          <template slot="updated_date" slot-scope="data">
            {{data.item.updated_date | formatDate('DD/MM/YYYY HH:mm:ss')}} 
          </template>
          <template slot="active" slot-scope="data">
            <b-badge :variant="getBadge(data.item.active)">{{data.item.active ? 'Active' : 'InActive' }}</b-badge>
          </template>
          <template slot="action" slot-scope="data" style="width:10px">
                  <b-dropdown class="float-right" variant="transparent text-muted p-0" right no-caret>
                    <template slot="button-content">
                      <i class="icon-settings"></i>
                    </template>
                    <!-- <b-dropdown-header class="font-weight-bold">Notification</b-dropdown-header> -->
                    <b-dropdown-item @click="changeEventHandler(data.item.id, true)"> Activate</b-dropdown-item>
                    <b-dropdown-item @click="changeEventHandler(data.item.id, false)"> Deactivate</b-dropdown-item>
                    <!-- <b-dropdown-item @click="deleteEventHandler(data.item)" v-b-modal.confirmDeleteModal v-b-modal.modal-center :disabled="validateStatusId(data.item)" title="Delete notification"> Delete</b-dropdown-item> -->
                    <!-- <b-dropdown-item @click="copyEventHandler(data.item.id, data.item.request_type_id)"> Copy </b-dropdown-item> -->
                    <!-- <b-dropdown-item v-if="data.item.request_type_id !== 1" @click="mofaEventHandler(data.item)" :disabled="validateStatusId(data.item)">MoFA</b-dropdown-item>
                    <b-dropdown-header class="font-weight-bold">Status</b-dropdown-header>
                    <b-dropdown-item @click="itemEventHandler(data.item, 14)" v-b-modal.confirmStatusModal v-b-modal.modal-center :disabled="data.item.status_id == 14" title="Submit notification to DLT"> Submit </b-dropdown-item>
                    <b-dropdown-item @click="itemEventHandler(data.item, 2)" v-b-modal.confirmStatusModal v-b-modal.modal-center :disabled="data.item.status_id !== 14" title="Postpone submitted notification"> Postpone</b-dropdown-item>
                    <b-dropdown-item @click="itemEventHandler(data.item, 1)" v-b-modal.confirmStatusModal v-b-modal.modal-center :disabled="data.item.status_id !== 14" title="Cancel submitted notification"> Cancel</b-dropdown-item>                   -->
                  </b-dropdown>                
          </template>
        </b-table>
        <nav>
          <b-pagination size="sm" :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" prev-text="Prev" next-text="Next" />
        </nav>
      </b-col>

      <!--// MODAL Confirm Save -->   
       <b-modal title="Confirm" class="modal-primary" id="confirmStatusModal" @ok="confirmStatusEventHandler" ok-title="Yes" cancel-title="No" centered>
          <p class="my-4">{{ message }}</p>     
      </b-modal>  
      <!--// MODAL Confirm Save -->  

      <!--// MODAL Confirm Delete -->   
       <b-modal title="Confirm" class="modal-primary" id="confirmDeleteModal" @ok="confirmDeleteEventHandler" ok-title="Yes" cancel-title="No" centered>
          <p class="my-4">{{ message }}</p>     
      </b-modal>  
      <!--// MODAL Confirm Delete -->  

    </b-row>
  </div>
</template>

<script>
import * as utils from '@/mixins/utils'
import * as constants from '@/store/constants'
import * as types from '@/store/types'
import { mapGetters } from 'vuex'
import NotificationService from '@/api/NotificationService'
import LandMovementService from '@/api/LandMovementService'
import TempVenueService from '@/api/TempVenueService'
import SeaService from '@/api/SeaService'
import AirService from '@/api/AirService'
import NSLService from '@/api/NSLService'
import CommonService from '@/api/CommonService'
import UserService from '@/api/UserService'
import Api from '@/api/Api'
import toast from '@/mixins/toast'

export default {
  name: 'c-table',  
  props: {
    caption: {
      type: String,
      default: 'Table'
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    },
    selectedAgencyId: {
      type: Number,
      default: 0
    }
  },
  data: () => {
    return {      
      fields: [
        {label:'Id#', key: 'id', sortable: true, class: 'sm="4"'},
        {label:'Username', key: 'username', sortable: true},             
        {label:'Firstname', key: 'firstname', sortable: true},
        {label:'Lastname', key: 'lastname', sortable: true},        
        {label:'Position', key: 'position', sortable: true},        
        {label:'Phone', key: 'phone', sortable: true},        
        {label:'Created Date', key: 'created_date', sortable: true},
        {label:'Updated Date', key: 'updated_date'},
        {label:'Email Address', key: 'email_address', sortable: true},
        {label:'Status', key: 'active', sortable: true},
        {key: 'action'}
      ],
      selectedItem: null,
      selectedStatusId: 0,
      message: null,
      currentPage: 1,
      perPage: 10,
      selectedItem: null,
      selectedStatusId: 0,
      message: null,
      pageOptions: [ 5, 10, 15 ],
      sortBy: 'id',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      isBusy: false,
      noProviderPaging: false,
      noProviderFiltering: false,
      noProviderSorting: false,
      agencyId: 0,
      totalRows: 0
    }
  },
  computed: {

    sortOptions () {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => { return { text: f.label, value: f.key } })
    },

    ...mapGetters({
        items : types.GET_USER_NOTIFICATION_LIST,
        totalRows : types.GET_TOTAL_ROWS,
        agencyList: types.GET_AGENCIES        
    })
  },
  created () {
      this.$store.dispatch(types.ACTION_FIND_AGENCIES)
      this.agencyId = this.$store.state.agencyId            
  },

  methods: {

    changeEventHandler(id, active) {

      let payload = { 
        id: id,
        active: active
      }


      UserService.updateStatus(payload).then( (response) => {
        if (response) {
           this.$refs.table.refresh()
          
           if (active)
              toast.success( "User account has now been activated")
           else 
              toast.success( "User account has now been deactivated")
        }
      });
        
    },

    validateStatusId(active) {
      console.log("active: "+ active)
        if (active) 
          return true
        else 
          return false
    },

    agencyChangeHandler(e) {
      this.agencyId = e
      this.$refs.table.refresh()
    },

    myProvider (ctx) {

      let _self = this
      ctx.searchField = this.sortBy
      let offset = ctx.perPage * (ctx.currentPage-1)      
      let promise = Api().get('/users/agency/'+ this.agencyId +'?keyword='+ (ctx.filter ? ctx.filter : '') +
                              '&field='+ ctx.searchField +
                              '&sortby='+  (ctx.sortBy ? ctx.sortBy : 'id') +
                              '&sortdesc='+ ctx.sortDesc +
                              '&offset='+ offset +
                              '&limit='+ ctx.perPage)

      // Must return a promise that resolves to an array of items
      return promise.then((response) => {
        // Pluck the array of items off our axios response
        //let items = response.data
         let items = response.data.items
        _self.totalRows = response.data.total_records
        // Must return an array of items or an empty array if an error occurred
        return(items || [])
      })
      .catch( error => {
            if (error.response) {
                  if (error.response.status = 401) {
                      toast.error( "Your session has expired.  Please login again.", "401: Unauthorized")
                      this.$router.replace('/login')
                  } 
                  else  {
                      toast.error( error.response.message, "Error")                      
                  }
                } else if (error.request) {
                  console.log(error.request)                      
                  toast.error( "An unexpected error occurred while processing the request.", "500: Backend Error")
                } else {
                  // Something happened in setting up the request that triggered an Error
                  console.log('Error', error.message);                      
                }
        })
    },

    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    getBadge (status) {
      return status === true ? 'success' : 'danger'
    },

    getRowCount (items) {
      return items.length
    },
    itemEventHandler(item, statusId) {
        this.selectedStatusId = statusId
        this.selectedItem = item

        let status = null

             if (statusId == 2) status = "Postpone"
        else if (statusId == 1) status = "Cancel"
        else if (statusId == 14) status = "Submit"  

        this.message = "Are you sure you want to "+ status.toUpperCase() + " this notification?"         
    },
    editEventHandler(notificationId, requestTypeId) {

       // get notification
       this.loadNotification(notificationId)

       if (requestTypeId === constants.FORM_LAND_MOVEMENT) {
            this.loadLandMovement(notificationId) 
       }
       else if (requestTypeId === constants.FORM_TEMP_VENUE) {
            this.loadTempVenue(notificationId) 
       }
       else if (requestTypeId === constants.FORM_SEA) {
            this.loadSea(notificationId) 
       }
       else if (requestTypeId === constants.FORM_AIR) {
            this.loadAir(notificationId) 
       }
       else if (requestTypeId === constants.FORM_NO_STRIKE_LIST) {
            this.loadNSL(notificationId) 
       }
       else if (requestTypeId === constants.FORM_ADMIN_LETTERS) {
            this.loadAdminLetters(notificationId) 
       }
    },

    deleteEventHandler(item) {

      this.selectedItem = item
      this.message = "Are you sure you want to DELETE this notification?"         
    },

    copyEventHandler(notificationId) {
      // copy notification implementation
    },
    mofaEventHandler(item) {
       this.$store.commit(types.MUTATE_VIEW_MOFA, true)
       this.$store.commit(types.MUTATE_NOTIFICATION_ID, item.id)
       this.$store.commit(types.MUTATE_REQUEST_TYPE_ID, item.request_type_id)

       const routeName = utils.findMofaNameById( item.request_type_id )

       setTimeout(function () {
            this.$store.dispatch(types.ACTION_FIND_MOFA, {type: routeName , id:item.id})
        }.bind(this), 600)
       
       // load MOFA form       
       this.$router.replace('/forms/'+ routeName +"-mofa")
    },
    confirmStatusEventHandler() {

      let item = this.selectedItem;
      let status = this.$_.find(this.$store.state.statusList, {id:this.selectedStatusId});
      let notes = this.$moment(new Date()).format('DD/MM/YYYY HH:mm:ss') +'\n'+ status.name
      // cancel notification
      const payload = {
            id : item.id,
            status_id : status.id,
            notes : notes,
            ehoc_ref: item.ehoc_ref,
            last_updated_by: this.$store.state.userId
        }
        this.$store.dispatch(types.ACTION_UPDATE_NOTIFICATION_STATUS, payload)
        // console.log("this.$store.state.userId: "+ this.$store.state.userId)

        setTimeout(function () {            
            //this.$store.dispatch(types.ACTION_USER_NOTIFICATION_LIST, this.$store.state.agencyId)
            this.$refs.table.refresh();            
            this.$store.dispatch(types.ACTION_DASHBOARD_STATISTICS, this.$store.state.agencyId)
        }.bind(this), 300)
    },

    confirmDeleteEventHandler() {
      let item = this.selectedItem;

      this.$store.dispatch(types.ACTION_DELETE_NOTIFICATION, item.id)
    
      setTimeout(function () {            
            // this.$store.dispatch(types.ACTION_USER_NOTIFICATION_LIST, this.$store.state.agencyId)
            this.$refs.table.refresh();            
      }.bind(this), 300)

    },

    loadNotification(notificationId) {
       // get notification
       NotificationService.fetchByNotificationId(notificationId).then( (resp) => {
          this.$store.commit(types.MUTATE_MODE, constants.MODE_EDIT)
          this.$store.commit(types.MUTATE_NOTIFICATION_ID, resp.id)
          this.$store.commit(types.MUTATE_USER_AGENCY_ID, resp.agency_id)
          this.$store.commit(types.MUTATE_PURPOSE_ID, resp.purpose_id)
          this.$store.commit(types.MUTATE_PURPOSE_OTHERS, resp.purpose_others)
          this.$store.commit(types.MUTATE_REQUEST_TYPE_ID, resp.request_type_id)
          this.$store.commit(types.MUTATE_MAP, {roadmap: resp.route_map_terrain, satellite: resp.route_map_satellite})          
          this.$store.commit(types.MUTATE_REQUEST_TYPE_ID, resp.request_type_id)
          this.$store.commit(types.MUTATE_EHOC_REF, resp.ehoc_ref)
          this.$store.commit(types.MUTATE_CENTCOM_REF, resp.centcom_ref)
          this.$store.commit(types.MUTATE_REQUEST_TYPE_ID, resp.request_type_id) 
          this.$store.commit(types.MUTATE_REQUESTED_BY, resp.requested_by)
          this.$store.commit(types.MUTATE_LAST_UPDATED_BY, resp.last_updated_by) 
          this.$store.commit(types.MUTATE_NOTES, resp.notes)
          this.$store.commit(types.MUTATE_STATUS_ID, resp.status_id)
          this.$store.commit(types.MUTATE_START_DATE, resp.start_date)
          this.$store.commit(types.MUTATE_REQUESTED_DATE, resp.request_date) 
       }) 
    },
    loadLandMovement(notificationId) {
       
       // get waypoints
       LandMovementService.getWaypoints(notificationId).then( (resp) => {
          this.$store.commit(types.MUTATE_WAYPOINTS, resp)          
       })

       // get convoys 
       LandMovementService.getConvoys(notificationId).then( (resp) => {    
          this.$store.commit(types.MUTATE_CONVOYS, resp)
       })

       // get participants 
       LandMovementService.getParticipants(notificationId).then( (resp) => {        
          this.$store.commit(types.MUTATE_PARTICIPANTS, resp)
       })

       // get vehicles 
       LandMovementService.getVehicles(notificationId).then( (resp) => {        
          this.$store.commit(types.MUTATE_VEHICLES, resp)
       })

       // get trucks 
       LandMovementService.getTrucks(notificationId).then( (resp) => {        
          this.$store.commit(types.MUTATE_TRUCKS, resp)
       })

       // get photos 
       LandMovementService.getPhotos(notificationId).then( (resp) => {        
          this.$store.commit(types.MUTATE_PHOTOS, resp)
       })

       // land movement
       this.$router.replace('/forms/land-movement')
    },
    loadTempVenue(notificationId) {

        TempVenueService.fetchByNotificationId(notificationId).then( (resp) => {
            if (resp) {
                this.$store.commit(types.MUTATE_VENUES, resp)
            }            
        })

        // get attachments
        CommonService.fetchAttachment(notificationId).then( (resp) => {
          this.$store.commit(types.MUTATE_ATTACHMENTS, resp)
        })

        // temp venue
       this.$router.replace('/forms/temp-venue')
    },
    loadSea(notificationId) {

       SeaService.fetchByNotificationId(notificationId).then( (resp) => {
          if (resp) {
              this.$store.commit(types.MUTATE_SEA, resp)
          }
       })

       // sea
       this.$router.replace('/forms/sea-movement')
    },
    loadAir(notificationId) {
        
        setTimeout(function () {
            this.$store.dispatch(types.ACTION_FIND_AIR, notificationId)
        }.bind(this), 600)

       // air
       this.$router.replace('/forms/air-movement')
    },
    loadNSL(notificationId) {

       NSLService.fetchByNotificationId(notificationId).then( (resp) => {
          if (resp) {
              this.$store.commit(types.MUTATE_NSL, resp)
          }
       })
       // NSL
       this.$router.replace('/forms/no-strike-list')
    },

    loadAdminLetters(notificationId) {

       CommonService.fetchAttachment(notificationId).then( (resp) => {
          this.$store.commit(types.MUTATE_ATTACHMENTS, resp)
       })

       // admin letters
       this.$router.replace('/forms/admin-letters')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/user/UserTable.vue